function getArticleData(){
    
}
function getads(){
    return [{
        id:1,
        image:"https://img.advertgallery.com/wp-content/uploads/2019/01/zomato-the-grandest-food-and-entertainment-carnival-is-coming-to-town-zomaland-ad-delhi-times-16-01-2019.png",
        url:"https:www.google.co.in"
    },
    {
        id:2,
        image:"https://img.advertgallery.com/wp-content/uploads/2017/10/swiggy-food-delivery-app-enjoy-flat-40-off-ad-pune-times-28-10-2017.jpg",
        url:"https://www.swiggy.com/"
    }]
}
export {
    getArticleData,
    getads
};